import { OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';

import Box from './Box';

// function ignore<T extends React.UIEvent>(e: T) {
//   e.stopPropagation();
//   e.preventDefault();
// }

function Entry() {
  return (
    <Canvas style={{ userSelect: 'none' }}>
      <ambientLight intensity={Math.PI / 2} />
      <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} decay={0} intensity={Math.PI} />
      <pointLight position={[-10, -10, -10]} decay={0} intensity={Math.PI} />
      <Box position={[-1.5, 0, 0]} />
      <Box />
      <Box position={[1.5, 0, 0]} />
      <OrbitControls />
    </Canvas>
  );
}

export default React.memo(Entry);
